import { gql as apolloGql } from '@apollo/client'
import type { DocumentNode } from 'graphql'
import { gql } from 'shared/types/layoutcreator'

export const SEND_TO_PRODUCTION: DocumentNode = apolloGql(/* GraphQL */ `
  mutation sendToProduction(
    $productionData: ProductionDataInput!
    $cover: Upload
  ) {
    sendToProduction(cover: $cover, productionData: $productionData)
  }
`)

export const DELETE_PRODUCTION_EXPORT: DocumentNode = apolloGql(/* GraphQL */ `
  mutation deleteProductionExport($id: String!) {
    deleteProductionExport(id: $id)
  }
`)

export const UPDATE_CUSTOM_ATTRIBUTE = gql(/* GraphQL */ `
  mutation updateCustomAttribute(
    $orderNumber: String!
    $year: Int!
    $customerNumber: String!
    $attributeKey: String!
    $value: CustomAttributeValueInput
  ) {
    updateCustomAttribute(
      orderNumber: $orderNumber
      year: $year
      customerNumber: $customerNumber
      attributeKey: $attributeKey
      value: $value
    )
  }
`)
